import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

export const UiSlider = (props) => {

    var settings = props.UiSliderSettings;

    return (
        <>
            <Slider {...settings} key={props.key}>
               {props.children}
            </Slider>

        </>
    )
}